import { useMemo } from "react";

import { mirrorColor } from "@corca/tiptap";

import type { GraphOptions } from "./types";

type ColorOpions = Pick<GraphOptions, "axesColor" | "gridColor" | "bgColor">;

export function useAppletThemeColors(
  { axesColor, gridColor, bgColor }: ColorOpions,
  theme: "dark" | "light",
): Required<ColorOpions> {
  return useMemo(() => {
    const isDark = theme === "dark";

    const themeGridColor = gridColor ?? "gray-200";
    const themeAxesColor = axesColor ?? "black";

    const themeBgLightColor = bgColor ?? "white";
    const themeBgDarkColor = bgColor ? mirrorColor(bgColor) : "gray-900";

    return {
      gridColor: isDark ? mirrorColor(themeGridColor) : themeGridColor,
      axesColor: isDark ? mirrorColor(themeAxesColor) : themeAxesColor,
      bgColor: isDark ? themeBgDarkColor : themeBgLightColor,
    };
  }, [gridColor, axesColor, bgColor, theme]);
}
